import { useEffect } from "react";
import { SparklesIcon } from "./icons.js";

export function SalesforceAuthorizationCompleteApp() {
  useEffect(() => {
    const timer = window.setTimeout(() => window.close(), 350);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <main className="assistant-activation-shell">
      <section className="assistant-activation-card" aria-labelledby="salesforce-authorization-complete-title">
        <div className="assistant-activation-card__brand">
          <span><SparklesIcon size={26} /></span>
          <div><strong>AI 助手</strong><small>Salesforce 当前用户安全连接</small></div>
        </div>
        <h1 id="salesforce-authorization-complete-title">连接已完成</h1>
        <p>本人 Salesforce 业务权限已经连接。您可以关闭此窗口，原来的 AI 助手会自动恢复。</p>
        <button className="button button--primary button--full" type="button" onClick={() => window.close()}>关闭窗口</button>
        <a className="button button--secondary button--full" href="/workspace">转到独立工作台</a>
      </section>
    </main>
  );
}
